import React from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";

export default function SLMReferencesPanel({
  referenceOptions,
  selectedSourceCategories1,
  selectedSourceCategories2,
  selectedSourceCategories3,
  sourceDate1,
  sourceDate2,
  sourceDate3,
  sourcePage1,
  sourcePage2,
  sourcePage3,
  onSource1Change,
  onSource2Change,
  onSource3Change,
  onDateChange,
  onPageChange,
  onBlur,
  createId,
}) {
  const compactRowStyle = { margin: 0 };
  const indexColProps = {
    xs: "auto",
    className: "d-flex align-items-center justify-content-center px-1 text-muted small",
  };

  return (
    <Card>
      <Card.Header className="py-1 px-2">References </Card.Header>

      <Card.Body className="px-2 py-1">
        <Row className="g-2 mb-1 mt-0 align-items-center" style={compactRowStyle} data-testid="references-panel-header-row">
          <Col {...indexColProps}> </Col>
          <Col>Reference</Col>
          <Col>Date</Col>
          <Col>Page</Col>
        </Row>
        <Row className="g-2 mb-1 align-items-center" style={compactRowStyle}>
          <Col {...indexColProps}>1</Col>
          <Col>
            <Select value={selectedSourceCategories1} onChange={onSource1Change} options={referenceOptions} inputId={createId("field", "source-cat-1", "input")} instanceId={createId("field", "source-cat-1", "instance")} id={createId("field", "source-cat-1", "select")} isClearable />
          </Col>
          <Col>
            <DatePicker id={createId("field", "source-date-1", "input")} selected={sourceDate1 !== null ? new Date(sourceDate1) : null} onChange={(value) => onDateChange(value, "source_date_1")} onBlur={onBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
          </Col>
          <Col>
            <Form.Control id={createId("field", "source-page-1", "input")} name="source_page_1" onChange={onPageChange} value={sourcePage1 ?? ""} as="input" type="number" min="0" step="1" onBlur={onBlur} />
          </Col>
        </Row>
        <Row className="g-2 mb-1 align-items-center" style={compactRowStyle}>
          <Col {...indexColProps}>2</Col>
          <Col>
            <Select value={selectedSourceCategories2} onChange={onSource2Change} options={referenceOptions} inputId={createId("field", "source-cat-2", "input")} instanceId={createId("field", "source-cat-2", "instance")} id={createId("field", "source-cat-2", "select")} isClearable />
          </Col>
          <Col>
            <DatePicker id={createId("field", "source-date-2", "input")} selected={sourceDate2 !== null ? new Date(sourceDate2) : null} onChange={(value) => onDateChange(value, "source_date_2")} onBlur={onBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
          </Col>
          <Col>
            <Form.Control id={createId("field", "source-page-2", "input")} name="source_page_2" onChange={onPageChange} value={sourcePage2 ?? ""} as="input" type="number" min="0" step="1" onBlur={onBlur} />
          </Col>
        </Row>
        <Row className="g-2 align-items-center" style={compactRowStyle}>
          <Col {...indexColProps}>3</Col>
          <Col>
            <Select value={selectedSourceCategories3} onChange={onSource3Change} options={referenceOptions} inputId={createId("field", "source-cat-3", "input")} instanceId={createId("field", "source-cat-3", "instance")} id={createId("field", "source-cat-3", "select")} isClearable />
          </Col>
          <Col>
            <DatePicker id={createId("field", "source-date-3", "input")} selected={sourceDate3 !== null ? new Date(sourceDate3) : null} onChange={(value) => onDateChange(value, "source_date_3")} onBlur={onBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
          </Col>
          <Col>
            <Form.Control id={createId("field", "source-page-3", "input")} name="source_page_3" onChange={onPageChange} value={sourcePage3 ?? ""} as="input" type="number" min="0" step="1" onBlur={onBlur} />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
